export default __webpack_public_path__ + "static/media/md-card-bg-nodejs.f27cfeca.png";